import { commonUtils } from './common_utils';
import { imageSlider } from './ad_listing_image_slider';
import { financeAdListing } from './finance_ad_listing';

export const adListing = {
    cachedAdData: [],
    scrollAtTop: true,
    loadingImageClass: 'global-loader-img-big',
    historySupport: false,
    sortOptionCookieName: 'last_sort_option',
    ajaxHiddenAdUrl: Routing.generate('ajax_hidden_ad'),
    init() {
        let $body = $('body');

        // for handling popstate event default call on chrome
        this.historySupport = typeof history.pushState === 'function';

        // create the initial state
        if (this.historySupport) {
            let initialState = this.createState({ path: window.location.href });
            history.replaceState(initialState, null, initialState.path);
        }

        // popstate event
        window.addEventListener('popstate', function (event) {
            if (!event.state || !event.state.path) {
                return;
            }

            adListing.fetchResults(event.state.path);
        });

        // Page navigation
        $body.on('click', '.pageNavigation', function (event) {
            // todo: check require this code or not after remove quick search
            let $listingSearchForm = $('#listingSearchForm');
            if ($listingSearchForm.length === 1) {
                $listingSearchForm.addClass('quick-search__show-hide-mobile');
            }

            event.preventDefault();
            let pageUrl = $(this).attr('href');

            adListing.createSearchLink(pageUrl);
            adListing.fetchResults(pageUrl);
        });

        // Sorting order selection box
        $body.on('change', '.selectNavigation', function (a) {
            a.preventDefault();
            adListing.scrollAtTop = false;

            let values = $(this).val().split('_');
            let pageUrl = location.href;

            pageUrl = adListing.escapeFieldsFromQueryString(pageUrl, 'sortCol');
            pageUrl = adListing.escapeFieldsFromQueryString(pageUrl, 'ord');
            pageUrl = adListing.escapeFieldsFromQueryString(pageUrl, 'page');

            if (values[0] === 'closest') {
                navigator.geolocation.getCurrentPosition(function (position) {
                    pageUrl = adListing.escapeFieldsFromQueryString(pageUrl, 'latitude');
                    pageUrl = adListing.escapeFieldsFromQueryString(pageUrl, 'longitude');
                    pageUrl = `${pageUrl + (pageUrl.indexOf('?') === -1 ? '?' : '&')}sortCol=${values[0]}&ord=${values[1]}`;
                    pageUrl = `${pageUrl}&latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`;
                    adListing.createSearchLink(pageUrl);
                    adListing.fetchResults(pageUrl);
                }, adListing.geoLocationError);
            } else {
                pageUrl = `${pageUrl + (pageUrl.indexOf('?') === -1 ? '?' : '&')}sortCol=${values[0]}&ord=${values[1]}`;
                adListing.createSearchLink(pageUrl);
                adListing.fetchResults(pageUrl);

                // save sorting options in cookie
                if ($(this).hasClass('saveSearchSorting')) {
                    commonUtils.setCookie(adListing.sortOptionCookieName, $(this).val(), 30 * 24 * 60);
                }

                // Change sorting option in advance search
                if ($('#advance_search').length) {
                    $('#advance_search #sortBy').val(values[0]);
                    $('#advance_search #sortOrder').val(values[1]);
                }
            }
        });

        financeAdListing.showFinanceOffer();
    },
    createState(params) {
        let state = {};
        const stateParams = params || {};
        state.path = stateParams.path;
        state.time = new Date().getTime();

        return state;
    },
    fetchResults(searchPath) {
        $(`.${this.loadingImageClass}`).show();
        if (this.scrollAtTop) {
            // keep its current position when change sorting option/all tabs dealer/seller/24h new/updated
            // In listing pages move user at top of the page
            let elementToScroll = $('#listingPageTop').length ? 'top' : 'listingData';
            window.scrollTo({ top: $(`#${elementToScroll}`).offset().top, left: 0, behavior: 'instant' });
        }

        if (this.cachedAdData[searchPath]) {
            this.displayAdList(this.cachedAdData[searchPath]);
        } else {
            $.get(searchPath, '', function (data) {
                if (data.error && data.url) {
                    window.location.replace(data.url);
                    return false;
                }

                adListing.cachedAdData[searchPath] = data;
                adListing.displayAdList(data);
                return undefined;
            });
        }
    },
    displayAdList(adInfo) {
        let $listingData = $('#listingData');
        $('.totalRecords').html(commonUtils.number_format(adInfo.total_ads, 0, ',', ' '));
        $listingData.html(adInfo.ad_listing_data);
        imageSlider.init();
        $('#paginationDataLargeView').html(adInfo.pagination_large_view);
        $('#paginationDataSmallView').html(adInfo.pagination_small_view);
        $('#sortingSelectionBox').html(adInfo.sorting_option);
        $('#sortingSelectionBoxSmall').html(adInfo.sorting_option_small_view);
        $('#sellerAndNewUpdateAdFilter').html(adInfo.quick_filter_option);

        if (adInfo.total_page > 0) {
            $('.totalCounter').show();
            $('.currentPage').html(`${adInfo.current_page}/${adInfo.total_page}`);
        } else {
            $('.totalCounter').hide();
        }

        if (0 === adInfo.total_ads) {
            $('.adListingNoRecord').css('display', 'flex');
            $listingData.html('');
        } else {
            $('.adListingNoRecord').hide();
            financeAdListing.showFinanceOffer();
        }

        $(`.${this.loadingImageClass}`).hide();

        // Hide and show banner element for mobile/desktop view to avoid duplicate banner loaded
        commonUtils.hideElementOnMobileView();
        if (!commonUtils.isDevEnvironment()) {
            this.reloadAlmaBanner();
        }

        this.scrollAtTop = true;
    },
    escapeFieldsFromQueryString(url, key) {
        return url
            .replace(new RegExp(`[?&]${key}=[^&#]*(#.*)?$`), '$1')
            .replace(new RegExp(`([?&])${key}=[^&]*&`), '$1');
    },
    geoLocationError(error) {
        if (error.code === 1) {
            window.$.colorbox({ inline: true, href: '#locationErrorModal' });
        }
    },
    createSearchLink(searchPath) {
        if (this.historySupport) {
            let state = this.createState({ path: searchPath });
            history.pushState(state, '', searchPath);
        }
    },
    reloadAlmaBanner() {
        // Reload/refresh alma banners
        if (
            window.ALMA &&
            window.ALMA.ad &&
            typeof window.ALMA.ad.info !== 'undefined' &&
            window.ALMA.ad.clear &&
            window.ALMA.ad.init &&
            window.ALMA.ad.loadAd
        ) {
            window.ALMA.ad.clear(); // Clears if class 'ad'
            window.ALMA.ad.init().then(function () {
                // do a full auction for current section, call loadAds after request is done
                window.ALMA.ad.info.placements.forEach(function (placement) {
                    window.ALMA.ad.loadAd(placement.divId);
                });
            });
        }
    },
    hideShowHiddenLink(isIncrement) {
        let $totalHiddenAdsElement = $('.totalHiddenAds');
        let totalHiddenAds = parseInt($totalHiddenAdsElement.data('ad-counter'), 10);
        totalHiddenAds = isIncrement ? totalHiddenAds + 1 : totalHiddenAds - 1;
        $totalHiddenAdsElement.data('ad-counter', totalHiddenAds);

        if (!$('.page-features__dont-show-hidden-ad-mobile').is(':visible')) {
            $('#hiddenAdCounter').text(` (${totalHiddenAds} ${Translations.pcs}) `);
        }

        // Do hide/show element for mobile view only
        if ($('.sticky-sub-header-mobile').is(':visible')) {
            $('.page-features__hidden-ad_for-mobile,.page-features__dont-show-hidden-ad-mobile').hide();
            if (totalHiddenAds > 0) {
                $('.page-features__hidden-ad_for-mobile').show();
            }
        } else if (totalHiddenAds > 0) {
            $('.showHideHiddenAds').css('display', 'flex');
        } else {
            $('.showHideHiddenAds').css('display', 'none');
        }
    },
};

// Load image slider before body is ready because slider taking time to load images
imageSlider.init();

$(function () {
    adListing.init();

    let $body = $('body');

    // Hide ad from search result - add ad to hidden list
    $body.on('click', '.hideAdFromSearchResult', function () {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init('search_results_hide_add');
            return false;
        }

        let id = $(this).data('adid');
        let makeName = $(this).data('make');
        let hideAdElement = $(this).closest('.product-card');
        let csrfToken = $('#app').data('csrf-hidden-ad');
        $.post(adListing.ajaxHiddenAdUrl, `id=${id}&hideFromSearch=Y&token=${csrfToken}`, function (data) {
            if (!data.status && data.message) {
                commonUtils.showNotification(data.message);
            } else if (data.status) {
                let hideAdContent = $('#hideAdFromSearchResultBlock').html();
                hideAdContent = hideAdContent.replaceAll('hidden_id', id).replace('hidden_make', makeName);
                $(hideAdElement).slideUp();
                $(hideAdContent).insertAfter(hideAdElement);

                adListing.hideShowHiddenLink(true);
            }
        });
        return undefined;
    });

    // Hide ad from search result - Undo ad from hide search result
    $body.on('click', '.showToSearchResult', function () {
        let id = $(this).data('adid');
        let hideAdElement = $(this).closest('.product-card').prev();
        let csrfToken = $('#app').data('csrf-hidden-ad');
        $.post(adListing.ajaxHiddenAdUrl, `id=${id}&hideFromSearch=N&token=${csrfToken}`, function (data) {
            if (!data.status && data.message) {
                commonUtils.showNotification(data.message);
            } else if (data.status) {
                $(`#hiddenBlock${id}`).remove();
                // Show favorite and compare buttons when unhiding
                $(hideAdElement).find('.addToFavouriteList, .compareAd').removeClass('none');
                $(hideAdElement).slideDown();
                adListing.hideShowHiddenLink(false);
            }
        });
    });

    // Hide ad from search result - remove ad from hidden list
    $body.on('click', '.removeAdFromHidden', function () {
        let $this = $(this);
        let id = $this.data('adid');
        let productCard = $this.closest('.product-card');
        let csrfToken = $('#app').data('csrf-hidden-ad');
        $.post(adListing.ajaxHiddenAdUrl, `id=${id}&hideFromSearch=N&token=${csrfToken}`, function (data) {
            if (data.status) {
                $this
                    .text(Translations.hide_from_search)
                    .prop('title', Translations.hide_from_search)
                    .removeClass('removeAdFromHidden product-card__ad-hide-remove');
                $this.addClass('hideAdFromSearchResult');
                // Show favorite and compare buttons when unhiding
                productCard.find('.addToFavouriteList, .compareAd').removeClass('none');
                adListing.hideShowHiddenLink(false);
            }
        });
    });

    // Quick filter options for large screen(select tab)
    $body.on('click', '.quickFilterTab', function (a) {
        a.preventDefault();
        adListing.scrollAtTop = false;
        adListing.createSearchLink($(this).attr('href'));
        adListing.fetchResults($(this).attr('href'));
    });

    // Quick filter options for small screen (selection box)
    $body.on('change', '.quickFilterSelect', function (a) {
        a.preventDefault();
        adListing.scrollAtTop = false;
        adListing.createSearchLink($(this).val());
        adListing.fetchResults($(this).val());
    });

    // Quick filter for custom select box
    $body.on('click', '.quickCustomFilter', function (event) {
        event.preventDefault();
        adListing.scrollAtTop = false;
        adListing.createSearchLink($(this).attr('href'));
        adListing.fetchResults($(this).attr('href'));
    });

    // Hide custom select box for quick filter
    $(document).on('focus', '.selectNavigation', function () {
        commonUtils.hideOpenedMenu();
    });

    // Hide and Show hidden ads
    $body.on('click', '.showHideHiddenAds', function (e) {
        e.preventDefault();

        let pageUrl = location.href;
        pageUrl = adListing.escapeFieldsFromQueryString(pageUrl, 'excludeHidden');
        if ($(this).attr('data-status') === 'false') {
            $('.showHideHiddenAds').attr('data-status', 'true').addClass('page-features__hidden-ad_show');

            // Do hide/show element for mobile view only
            if ($('.sticky-sub-header-mobile').is(':visible')) {
                $('.page-features__hidden-ad_for-mobile').hide();
                $('.page-features__dont-show-hidden-ad-mobile').show();
            }
            pageUrl = `${pageUrl + (pageUrl.indexOf('?') === -1 ? '?' : '&')}excludeHidden=true`;
        } else {
            $('.showHideHiddenAds').attr('data-status', 'false').removeClass('page-features__hidden-ad_show');

            // Do hide/show element for mobile view only
            if ($('.sticky-sub-header-mobile').is(':visible')) {
                $('.page-features__hidden-ad_for-mobile').show();
                $('.page-features__dont-show-hidden-ad-mobile').hide();
            }
        }

        adListing.createSearchLink(pageUrl);
        adListing.fetchResults(pageUrl);
    });

    // Datalayer event when ad clicked from fast lane
    $('.datalayerClickedEvent').on('click', function () {
        let fastlaneDatalayerData = $(this).closest('.gtmDataLayerFastLaneAd');
        let fastlaneDatalayerAdData = fastlaneDatalayerData.data('datalayer') || '';
        if (fastlaneDatalayerAdData) {
            let datalayerListLocation = fastlaneDatalayerData.data('datalayer-list-location');
            let position = fastlaneDatalayerData.data('position') || 1;
            commonUtils.dataLayer.genericData({
                event: 'ohituskaistaClick',
                position,
            });
            commonUtils.dataLayer.productListClickDataLayerEvent(
                fastlaneDatalayerAdData,
                'Ohituskaista',
                datalayerListLocation
            );
        }
    });

    $('.showcase-tooltip')
        .mouseenter(function () {
            $('.showcase-tooltip').addClass('Show_Tooltip_block');
        })
        .mouseleave(function () {
            setTimeout(function () {
                $('.showcase-tooltip').removeClass('Show_Tooltip_block');
            }, 500);
        });

    $('.deliveryTooltip, .warrantyTooltip').click(function () {
        const elementData = $(this).data();
        const $currentTooltip = $(`#${elementData.tooltipName}TooltipId_${elementData.id}`);
        // Hide all tooltips other than the current one
        $('.badge-with-info__tooltip').not($currentTooltip).hide();
        // Toggle the current tooltip visibility
        $currentTooltip.toggle();
    });
});
